import { failHandshake } from '@purple-dot/libraries/src/iframe-connect';

failHandshake({
  message: window.__DATA__.message,
  reason: window.__DATA__.reason,
  sandbox: window.__DATA__.sandbox,
});
